import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import RequirementsPage from "./pages/RequirementsPage";
import InvestituresPage from "./pages/InvestituresPage";
import UploadProof from "./pages/UploadProof";
import ProgressionPage from "./pages/ProgressionPage";
import SubmitMemoire from "./pages/SubmitMemoire";
import DashboardDistrict from "./pages/DashboardDistrict";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardRegion from "./pages/DashboardRegion";
import AspirantsRegionPage from "./components/region/AspirantsRegionPage";
import DashboardAdmin from "./pages/DashboardAdmin";
import ListsUser from "./components/admin/listsUser";
import RequirementsAdmin from "./components/admin/requirementsAdmin";
import ProofsAdmin from "./components/admin/proofAdmin";
import DashboardLayout from "./pages/Dashboard"; 
import LandingFepetra from "./pages";
import RegisterPage from "./pages/RegisterPage";
import MemoireViewer from "./pages/MemoireViewer";
import AdminLayout from "./layouts/AdminLayout";
import DistrictLayout from "./layouts/DistrictLayout";
import InvestituresDistric from "./components/district/investituresDistric";
import ValidationMemoireDistric from "./components/district/validationMemoireDistric";
import RegionLayout from './layouts/RegionLayout'
import MemoiresRegionPage from "./components/region/MemoiresRegionPage";
import EgliseLayout from "./layouts/EgliseLayout";
import AspirantsEglise from "./components/eglise/AspirantsEglise";
import PreuvesEglise from "./components/eglise/PreuvesEglise";
import MemoiresEglise from "./components/eglise/MemoiresEglise";
import InvestituresEglise from "./components/eglise/InvestituresEglise";
import ValidationProofsDistrictWithComments from "./components/district/ValidationProofsDistrictWithComments";
import RegionRequirementsAdded from "./components/region/RegionRequirementsAdded";
import MemoiresDistrictManager from "./components/region/MemoiresDistrictManager";
import MemoiresAdmin from "./components/admin/memoiresAdmin";
import PreuvesRegion from "./components/region/PreuvesRegion";
import DocumentViewer from "./components/district/DocumentViewer";
import DocumentViewerAdmin from "./components/admin/DocumenViewerAdmin";
import DocumentViewerEglise from "./components/eglise/DocumentViewerEglise";
import AspirantsAdmin from "./components/admin/AspirantsAdmin";
import LocationsAdmin from "./components/admin/LocationsAdmin";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingFepetra />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Admin */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<DashboardAdmin />} />
          <Route path="users" element={<ListsUser />} />
          <Route path="aspirants" element={<AspirantsAdmin />} />
          <Route path="requirements" element={<RequirementsAdmin />} />
          <Route path="proofs" element={<ProofsAdmin />} />
          <Route path="memoires" element={<MemoiresAdmin />} />
          <Route path="locations" element={<LocationsAdmin />} />
          <Route path="viewerAdmin" element={<DocumentViewerAdmin />} />
          
        </Route>
        <Route path="/memoire/:id" element={<MemoireViewer />} />

        {/* Église */}
        <Route path="/dashboard-eglise" element={<ProtectedRoute><EgliseLayout /></ProtectedRoute>}>
          <Route index element={<AspirantsEglise />} />
          <Route path="aspirants" element={<AspirantsEglise />} />
          <Route path="preuves" element={<PreuvesEglise />} />
          <Route path="memoires" element={<MemoiresEglise />} />
          <Route path="investitures" element={<InvestituresEglise />} />
          <Route path="viewerEglise" element={<DocumentViewerEglise />} />
        </Route>

        {/* Coordinateur District */}
        <Route path="/dashboard-district" element={<ProtectedRoute><DistrictLayout /></ProtectedRoute>}>
          <Route index element={<DashboardDistrict />} />
          <Route path="investitures" element={<InvestituresDistric />} />
          <Route path="preuves" element={<ValidationProofsDistrictWithComments />} />
          <Route path="memoires" element={<ValidationMemoireDistric />} />
          <Route path="viewer" element={<DocumentViewer />} />
        </Route>

        {/* Coordinateur Région */}
        <Route path="/dashboard-region" element={<ProtectedRoute><RegionLayout /></ProtectedRoute>}>
          <Route index element={<DashboardRegion />} />
          <Route path="aspirants" element={<AspirantsRegionPage />} />
          <Route path="preuves" element={<PreuvesRegion />} />
        </Route>

        {/* Élève : tableau de bord avec sous-pages */}
        <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route index element={<RequirementsPage />} />
          <Route path="requirements" element={<RequirementsPage />} />
          <Route path="proofs" element={<UploadProof />} />
          <Route path="memoire" element={<SubmitMemoire />} />
          <Route path="progression" element={<ProgressionPage />} />
          <Route path="investitures" element={<InvestituresPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;

